import { CustomerRolesActions, CustomerRolesActionTypes } from '@appStore/customers/actions/customer-roles.actions';
import { ClientRole } from '@model';

export interface State {
  loading: boolean;
  loaded: boolean;
  data: ClientRole[];
}

export const initialState: State = {
  loading: false,
  loaded: false,
  data: []
};

export function reducer(state = initialState, action: CustomerRolesActions): State {
  switch (action.type) {
    case CustomerRolesActionTypes.CustomerRolesLoadData:
      return { ...state, loading: true, loaded: false };
    case CustomerRolesActionTypes.CustomerRolesSuccess:
      return { ...state, data: action.payload, loading: false, loaded: true };
    case CustomerRolesActionTypes.CustomerRolesFail:
      return { ...state, data: [], loading: false, loaded: false };
  }
  return state;
}

export const getCustomerRoles = (state: State) => state.data;
export const getCustomerRolesLoading = (state: State) => state.loading;
export const getCustomerRolesLoaded = (state: State) => state.loaded;
